<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-list-item',
    props: {
      to: {
        type: String
      },
      text: {
        type: String
      },
      fontSize: {
        type: String,
        default: 'xl',
        validator: v => ['sm', 'md', 'lg', 'xl'].indexOf(v) !== -1
      },
      icon: {
        type: String,
        validator: v => v.startsWith('ph-')
      },
      iconSrc: {
        type: String,
        required: false
      },
      iconSize: {
        type: [String, Number],
        default: 24
      },
      bubble: {
        type: Number,
        default: 0
      },
      bubbleType: {
        type: String,
        default: 'number',
        validator: v => ['number', 'dot'].indexOf(v) !== -1
      },
      color: {
        type: String,
        default: 'black',
        validator: v =>
          [
            'black',
            'white',
            'concrete',
            'platinum',
            'silver',
            'gray',
            'granite',
            'black',
            'yellow',
            'blue',
            'green',
            'orange',
            'purple',
            'red'
          ].indexOf(v) !== -1
      },
      active: {
        type: Boolean,
        default: false
      },
      inverted: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        hovered: false
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX']),
      isActive() {
        return this.active || this.hovered
      },
      bubbleClass() {
        return this.bubbleType === 'number'
          ? [
              'absolute',
              '-top-3',
              '-right-3',
              'rounded-full',
              'bg-red',
              'text-white',
              'text-12',
              'font-semibold',
              'flex',
              'justify-center',
              'items-center',
              'min-w-5',
              'min-h-5',
              'px-1'
            ]
          : ['absolute', '-top-1', '-right-1', 'rounded-full', 'bg-red', 'min-w-2', 'min-h-2']
      }
    },
    watch: {
      active(newVal) {
        if (!newVal) this.hovered = false
      }
    },
    render(h) {
      const wrapper = this.to ? 'router-link' : 'div'

      return h(
        wrapper,
        {
          ref: this.ref,
          props: this.to && {
            to: this.to
          },
          nativeOn: this.to &&
            !this.active && {
              mouseover: () => (this.hovered = true),
              mouseleave: () => (this.hovered = false)
            },
          class: [
            'flex',
            'items-center',
            'w-full',
            'max-w-full',
            'gap-4',
            'p-2',
            'transition-colors',
            'duration-200',
            'rounded-lg',
            ...((this.isActive && !this.inverted) || (!this.isActive && this.inverted) ? ['bg-white'] : ['bg-transparent'])
          ]
        },
        [
          ...(this.icon
            ? [
                h(
                  this.icon,
                  {
                    attrs: {
                      size: this.iconSize,
                      color: this.isActive ? this.$helpers.getCorrectColor(this.themeColorHEX) : `text-${this.color}`
                    },
                    class: ['shrink-0', 'my-1', 'ml-1', this.bubble !== 0 ? 'relative' : '']
                  },
                  ...(this.bubble !== 0
                    ? [
                        h('div', {
                          class: this.bubbleClass,
                          domProps: {
                            innerHTML: `<span>${this.bubble > 99 ? '99+' : this.bubble}</span>`
                          }
                        })
                      ]
                    : [])
                )
              ]
            : this.iconSrc
            ? [
                h(
                  'div',
                  {
                    class: [
                      'w-6',
                      'h-6',
                      'shrink-0',
                      'my-1',
                      'ml-1',
                      this.isActive ? '' : `text-${this.color}`,
                      this.bubble !== 0 ? 'relative' : ''
                    ],
                    style: {color: this.isActive ? this.$helpers.getCorrectColor(this.themeColorHEX) : ''}
                  },
                  [
                    h('div', {
                      class: ['w-full', 'h-full', 'flex', 'justify-center', 'items-center'],
                      domProps: {
                        innerHTML: this.iconSrc
                      }
                    }),
                    ...(this.bubble !== 0
                      ? [
                          h('div', {
                            class: this.bubbleClass,
                            domProps: {
                              innerHTML: `<span>${this.bubbleType === 'number' ? (this.bubble > 99 ? '99+' : this.bubble) : ''}</span>`
                            }
                          })
                        ]
                      : [])
                  ]
                )
              ]
            : []),
          ...(this.text
            ? [
                h('t-text', {
                  props: {
                    size: this.fontSize,
                    color: this.color,
                    branded: this.isActive
                  },
                  domProps: {
                    innerHTML: this.text
                  },
                  class: ['max-w-full', 'truncate', 'py-px2', 'my-1']
                })
              ]
            : [])
        ]
      )
    }
  }
</script>
